import { all } from "redux-saga/effects";
import {
  alertCreateWatcher,
  alertDeleteWatcher,
  alertEditWatcher,
  alertStatusWatcher,
  alertTableWatcher,
  alertViewWatcher,
} from "../alert-saga";

export default function* alertRootSaga() {
  yield all([
    alertCreateWatcher(),
    alertTableWatcher(),
    alertViewWatcher(),
    alertEditWatcher(),
    alertDeleteWatcher(),
    alertStatusWatcher(),
  ]);
}
